import { Box, ButtonBase, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import ITour from "../models/ITour";

interface TourSelectorProps {
    tours: ITour[];
    selectedValue: number;
    onChange: (value: number) => void;
}

const TourSelector: React.FC<TourSelectorProps> = ({ selectedValue, onChange, tours }) => {
    const { t } = useTranslation();
    return (
        <Box
            mb={2}
            mt={2}
            display={"flex"}
            flexDirection={"row"}
            gap={"2px"}
            width={"100%"}
            sx={(theme) => ({
                position: "sticky",
                top: 60,
                [theme.breakpoints.up("sm")]: {
                    top: 66,
                },
                zIndex: 4,
                borderRadius: "8px",
                backgroundColor: "#262d35b6",
                boxShadow: "0px 0px 8px 0px #3d4a58b6",
                backdropFilter: "blur(16px)",
                ...theme.applyStyles("dark", {
                    backgroundColor: "#262d35b6",
                    boxShadow: "0px 0px 4px 0px #ffffffb6"
                }),
            })}
        >
            {tours.map((tour) => (
                <ButtonBase key={`tour-selector-tour-${tour.id}`} sx={{ width: "100%" }}>
                    <Box
                        width={"100%"}
                        display={"flex"}
                        flexDirection={"column"}
                        justifyContent={"center"}
                        alignItems={"center"}
                        p={0}
                        pl={2}
                        pr={2}
                        pt={"8px"}
                        onClick={() => onChange(tour.id)}
                        sx={(theme) => ({
                            cursor: "pointer",
                            borderRadius: "8px",
                            transition: "background-color 0.5s",
                            ":hover": {
                                backgroundColor: "#0000000a",
                                ...theme.applyStyles("dark", {
                                    backgroundColor: "#ffffff15",
                                })
                            }
                        })}
                    >
                        <Box
                            mb={"5px"}
                            display={"flex"}
                            flexDirection={"row"}
                            pb={"4px"}
                        >
                            <Typography
                                mt={"2px"}
                                ml={1}
                                fontWeight={selectedValue === tour.id ? 600 : 500}
                                color={selectedValue === tour.id ? "text.primary" : "text2.secondary"}
                                variant="h5"
                            >
                                {t(tour.name)}
                            </Typography>
                        </Box>
                        <Box sx={{
                            height: "4px",
                            width: selectedValue === tour.id ? "90%" : "0%",
                            transition: "width 360ms",
                            borderRadius: "16px",
                            bgcolor: (theme) => theme.palette.primary.main
                        }}
                        />
                    </Box>
                </ButtonBase>
            ))}

        </Box>
    );
};

export default TourSelector;
